// How the account pages name the person and their team (EV-client-1002).
const ROLE_LABEL = { owner: "Owner", admin: "Admin", member: "Member" };

export const displayName = (userData) => {
  if (!userData) return "";
  const full = [userData.firstName, userData.lastName].filter(Boolean).join(" ");
  return full || userData.name || "";
};

// "Rivera & Cole Immigration Law · Admin", or "" without a team.
export const teamLine = (userData, teamData) => {
  if (!userData || !userData.teamId || !teamData) return "";
  const role = ROLE_LABEL[userData.teamRole];
  return [teamData.name, role].filter(Boolean).join(" · ");
};
